export const urls = {
  picUrl: 'http://localhost/attachment/', //图片前缀
  picUrl2: '/attachment/', //图片前缀
  notice: '/SvpNews/notice', //公告
  news: '/SvpNews/news', //新闻
  carousel: '/SvpNews/carousel', //轮播图
  svpNews: '/SvpNews',
  link: '/SvpLink', //友情链接
  opinion: '/SvpOpinion', //意见反馈  参数 nickname mobile address email opinion
  apply: '/SvpApply', //搭载需求申请
  voyage: '/SvpCruisePlan', //共享航次计划
  SvpCruiseInfo: '/SvpCruiseInfo', //共享航次计划本年的列表
  cs: '/SvpCs', //首席科学家
  SvpCsApplyQuestion: 'SvpCsApplyQuestion', // 首席申请问题
  SvpCsApplyAnswer: '/SvpCsApplyAnswer', //首席申请答案
  SvpCsApply: '/SvpCsApply', //首席申请
  SvpCsQuestionnaire: '/SvpCs/questionnaire', // 首席科学家问卷列表
  SvpCsAssessmentQuestion: '/SvpCsAssessmentQuestion', // 首席科学家问卷列表
  SvpCsAssessmentAnswer: '/SvpCsAssessmentAnswer', // 首席科学家问卷提交
  SvpConfig: '/SvpConfig', // Config 信息
  SvpDictSeaArea: '/SvpDictSeaArea', // 字典：海区
  SvpDictSubject: '/SvpDictSubject', // 字典：学科
  SvpFindPassword: '/SvpFindPassword/sendEmail', // 找回密码
  //sys
  userLogin: '/sys/login',
  modifiedUsers: '/sys/user/save_reset_pwd',
  resetListBody: '/sys/user/list_reset_pwd',
  modifyPwd: '/sys/user/reset_pwd',
  register: '/sys/user/register',
  checkUserName: '/sys/user/checkUserName',
  userInfo: '/sys/user/info',
  updatePassword: '/sys/user/password'
};